import React from 'react';
// @ts-ignore
import styles from './TimePickerCustom.module.scss';
import FormCard from '../FormCard/FormCard';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from '../../Services/AppContext';
import { joinClasses } from '../../Utils/className.util';

export default function TimePickerCustom(props) {
	const { times, onChange, value } = props;
	const { translation } = useAppContext();

	const [toggled, setToggled] = useState(false);
	const [selected, setSelected] = useState(null);

	useEffect(() => {
		if (value) {
			setSelected(value);
			setToggled(true);
		}
	}, []);

	const handleTogglePicker = () => {
		setToggled(prev => !prev);
	};

	const handleSelectTime = time => {
		setSelected(time);

		onChange?.(time);
	};

	return (
		<FormCard style={{ height: '100%' }}>
			<div className={`custom-picker ${toggled ? 'toggled picked' : ''}`}>
				<div className='custom-picker__header' onClick={handleTogglePicker}>
					<div className='custom-picker__header__content'>
						<div className='custom-picker__header__content__title'>
							{translation['base.shared.time']}
						</div>
						<div className='custom-picker__header__content__value'>
							{selected
								? selected.from + ' - ' + selected.to
								: translation['base.pickTime']}
						</div>
					</div>
					<div className='custom-picker__header__icon'>
						<i className='fa-solid fa-angle-down' />
					</div>
				</div>
				{toggled && (
					<>
						<hr />
						<div className='custom-picker__body'>
							{times && times.length > 0 && (
								<>
									{times.map((time, index) => {
										const active =
											selected &&
											selected.date === time.date &&
											selected.from === time.from &&
											selected.to === time.to;

										return (
											<div
												key={index}
												className={joinClasses([
													'custom-picker__body__item',
													active ? 'active' : '',
													active ? styles.active : '',
													styles.wrapper,
												])}
												onClick={() => handleSelectTime(time)}>
												<div className={styles.interval}>
													{time.from} - {time.to}
												</div>
												{time.price && (
													<div className={styles.price}>{time.price}</div>
												)}
											</div>
										);
									})}
								</>
							)}
						</div>
					</>
				)}
			</div>
		</FormCard>
	);
}

TimePickerCustom.propTypes = {
	onChange: PropTypes.function,
};
